// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__mL0td","inner":"style_inner__2i_Wg","bottom":"style_bottom__3NOfN","copyright":"style_copyright__3nzaK"};